import { useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./styles.scss";
import { Box, Typography } from "@mui/material";
import InputField from "../InputField";

const PhoneNumberInput = ({
  wrapperId,
  label,
  disabled,
  prefixName,
  phoneNumberName,
  prefixValue,
  phoneNumber,
  phoneNumberPlaceholder,
  setFieldValue,
  handleChange,
  handleBlur,
  touched,
  errors,
}) => {
  useEffect(() => {
    const selectedFlag = document.querySelector(`#${wrapperId} .selected-flag`);

    if (selectedFlag && !selectedFlag.querySelector(".custom-flag-info")) {
      // Create wrapper div
      const wrapper = document.createElement("div");
      wrapper.className = "custom-flag-info";

      // Create phone display
      const phoneEl = document.createElement("span");
      phoneEl.className = "phone-text";
      phoneEl.textContent = prefixValue;

      // Create image
      const imgEl = document.createElement("img");
      imgEl.className = "phone-icon";
      imgEl.src = "/icons/arrow-down.svg";
      imgEl.alt = "phone icon";

      // Append
      wrapper.appendChild(phoneEl);
      wrapper.appendChild(imgEl);
      selectedFlag.appendChild(wrapper);
    } else if (selectedFlag) {
      // Update phone text dynamically
      const phoneEl = selectedFlag.querySelector(".phone-text");
      if (phoneEl) phoneEl.textContent = prefixValue;
    }
  }, [prefixValue, prefixName, setFieldValue, wrapperId]);

  return (
    <Box
      id={wrapperId}
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        pointerEvents: disabled ? "none" : "auto",
      }}
    >
      {label ? (
        <Typography
          color="rgba(47, 43, 61, 0.9)"
          sx={{
            fontSize: "15px",
            fontWeight: 500,
            opacity: disabled ? 0.5 : 1,
          }}
        >
          {label}
        </Typography>
      ) : null}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        }}
      >
        <Box
          className="phone-input-wrapper"
          sx={{
            flex: 1,
            display: "flex",
            gap: "6px",
            position: "relative",
          }}
        >
          <Box
            sx={{
              opacity: disabled ? 0.5 : 1,
            }}
          >
            <PhoneInput
              name={prefixName}
              country="il"
              value={prefixValue}
              onChange={(value, country) => {
                setFieldValue(prefixName, `+${country.dialCode}`);
              }}
              enableSearch={true}
              inputProps={{ dir: "ltr" }}
            />
          </Box>

          <InputField
            name={phoneNumberName}
            type="tel"
            value={phoneNumber}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={phoneNumberPlaceholder}
            disabled={disabled}
          />
        </Box>

        {touched[phoneNumberName] && errors[phoneNumberName] && (
          <Typography sx={{ color: "#d32f2f", fontSize: "13px" }}>
            {errors[phoneNumberName]}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default PhoneNumberInput;
